import Vue from 'vue'
import App from './App.vue'

import router from './router'

import firebase from 'firebase/app'
import './db/index'


Vue.config.productionTip = false

let app;

firebase.auth().onAuthStateChanged(user => {

  if (!app) {
    app = new Vue({
      el: '#app',
      router,
      components: {App},
      template: '<App/>',
    })    
  }
  
})



// WEBPACK FOOTER //
// ./src/main.js